<template>
  <d-card class="card-small mb-3">
    <d-card-header class="border-bottom">
      <h6 class="m-0">Distribuidores Atribuídos</h6>
    </d-card-header>

    <d-card-body class="p-0">
      <table class="table mb-0">
        <tbody>
          <tr v-for="(row, index) in distributors" :key="index">
            <td class="td-1">{{ index + 1 }}</td>
            <td class="td-2 link">
              <d-link
                :to="{
                  name: 'admin-distributor-edit',
                  params: { id: row.id },
                }"
              >
                {{ row.name }}
              </d-link>
            </td>
          </tr>
          <tr v-if="distributors.length === 0">
            <td colspan="2" class="no-content">
              Nenhum distribuidor foi atribuído
            </td>
          </tr>
        </tbody>
      </table>
    </d-card-body>
  </d-card>
</template>

<script>
export default {
  name: 'assigned-distributors',
  props: {
    distributors: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss" scoped>
.table tr:first-child td {
  border: none;
}
.td-1 {
  max-width: 10px;
}
</style>
